module.exports = __webpack_public_path__ + "static/media/souse_hot.683b604f.png";